import React from 'react';
import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ThemeToggle } from './ThemeToggle';
import { MobileNav } from './MobileNav';
import { useNavigation } from '../hooks/useNavigation';

export function Header() {
  const { navigateToSection } = useNavigation();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    navigateToSection(id);
  };

  return (
    <header className="w-full py-4 px-6 bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm fixed top-0 z-50 border-b border-gray-100 dark:border-gray-800">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 animate-fade-in hover:opacity-80 transition-opacity">
          <Heart className="w-6 h-6 text-primary-500" />
          <span className="text-xl font-semibold text-gray-900 dark:text-white">CloseCircle</span>
        </Link>

        <div className="flex items-center gap-4">
          <nav className="hidden md:flex items-center gap-8">
            <a 
              href="#features" 
              onClick={(e) => handleClick(e, 'features')} 
              className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
            >
              Features
            </a>
            <a 
              href="#privacy" 
              onClick={(e) => handleClick(e, 'privacy')} 
              className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
            >
              Privacy
            </a>
            <Link 
              to="/qa" 
              className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
            >
              Q&A
            </Link>
            <a 
              href="#waitlist" 
              onClick={(e) => handleClick(e, 'waitlist')} 
              className="bg-primary-500 text-white px-4 py-2 rounded-full hover:bg-primary-600 transition-all transform hover:scale-105"
            >
              Join Waitlist
            </a>
          </nav>
          <ThemeToggle />
          <MobileNav />
        </div>
      </div>
    </header>
  );
}